//这里公开UI的对外接口

import * as THREE from 'three';


export class UIApi{
	constructor(web3DView){
		this.web3DView = web3DView;		
	}

	//显示汽车自动驾驶控制台
	showCarNavControl(navOption){
		this.web3DView.$refs.navControlPanel.showSelf = true;
		if(navOption){
		  this.web3DView.$refs.navControlPanel.adjStyle(navOption.style);	
		}
	}

	//隐藏汽车自动驾驶控制台
	hideCarNavControl(){
		this.web3DView.$refs.navControlPanel.showSelf = false;		
	}

	//显示飞行模式控制台
	showFlyNavControl(navOption){
		this.web3DView.$refs.flyNavControlPanel.showSelf = true;
		if(navOption){
		   this.web3DView.$refs.flyNavControlPanel.adjStyle(navOption.style);
		}
	}

	//隐藏飞行模式控制台
	hideFlyNavControl(){
		this.web3DView.$refs.flyNavControlPanel.showSelf = false;		
	}


	showMapView(mapOption){
		this.web3DView.showMap = true;
		this.web3DView.$nextTick(()=>{
		   this.web3DView.map.resetMap();
		})
		if(mapOption){
		     this.web3DView.adjStyle(mapOption.style);
		}
	}

	hideMapView(){
		this.web3DView.showMap = false;		
	}
    
    //显示和隐藏桩号
    showStatusCard(cardOption){
		this.web3DView.showStatusCard=true;
		if(cardOption){
		   this.web3DView.statusCardStyle=cardOption.style;
		}

	}

	hideStatusCard(){
		this.web3DView.showStatusCard=false;
	}

    //显示添加病害面板
	showAddBadPanel(option){
		this.web3DView.$refs.badControlPanel.showSelf = true;
		if(option){
		   this.web3DView.$refs.badControlPanel.adjStyle(option.style);
		}
	}
    // 隐藏病害面板
	hideAddBadPanel(){
		this.web3DView.$refs.badControlPanel.showSelf = false;		
	}
}


// WEBPACK FOOTER //
// ./src/plugins/js/apis/uiapi.js